import { Link } from "react-router-dom"

const Missing = () => {
    return (
        <article style={{ padding: "100px" }}>
            <h1>Error</h1>
            <p>La página no existe</p>
            <div className="flexGrow">
                <Link to="/">Volver</Link>
            </div>
        </article>
    )
}

export default Missing
